const NautilusIcon  = ({color = "#17253C", size = 24, fill = ""}) => {
  return (
    <svg width={size} height={size} viewBox="0 1 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4142 14.8432C13.6481 15.0143 14.0985 15.1155 14.3324 15.119C14.7233 15.1225 15.0794 15.0597 15.4425 14.7944C15.8614 14.4872 16.1825 13.9251 16.2454 13.5272C16.399 12.5672 16.1686 11.8725 15.638 11.1464C15.254 10.6227 14.7268 10.1933 14.1753 9.98738C12.6812 9.42884 11.1486 9.64178 9.85002 10.5913C9.33686 10.9683 8.84813 11.5339 8.52697 12.0784C7.45177 13.9007 7.48319 16.484 8.9354 18.4703C9.15882 18.7775 9.45206 19.1196 9.73482 19.3884C12.2134 21.7308 16.1267 21.9437 19.0765 19.7864C20.2215 18.9485 21.2478 17.5661 21.6598 16.6829C23.1155 13.5586 22.7001 10.1235 20.6614 7.3308C19.2266 5.36891 16.982 4.11218 14.9712 3.65837C12.0004 3.00207 8.77482 3.57458 6.12871 5.50855C4.03068 7.04455 2.70762 9.11815 1.985 11.4571C1.10879 14.2952 1.25889 18.1631 3.24871 21.1304C3.36391 21.3049 3.60129 21.3433 3.76886 21.2176L8.42922 17.7372"
        fill={fill}
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M14.0458 15.2134C14.0458 15.2134 12.9322 16.2746 13.1905 17.9433C13.4489 19.6084 12.3213 20.7151 12.3213 20.7151"
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M16.0566 14.4453C16.0566 14.4453 16.6606 15.8591 18.3153 16.2012C19.9665 16.5399 20.6088 17.9851 20.6088 17.9851"
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M16.2837 11.5898C16.2837 11.5898 17.7987 11.7749 18.9089 10.5286C20.0225 9.28234 21.5759 9.44991 21.5759 9.44991"
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M13.7461 9.63505C13.7461 9.63505 14.8003 8.44465 14.3849 6.75504C13.973 5.06544 15.0342 3.82617 15.0342 3.82617"
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M9.61939 10.5532C9.61939 10.5532 9.57401 8.96486 8.1183 8.01533C6.6591 7.06231 6.59277 5.43555 6.59277 5.43555"
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M7.75223 13.7925C7.75223 13.7925 6.53041 12.7941 4.87223 13.2689C3.21405 13.7437 1.94336 12.7383 1.94336 12.7383"
        stroke={color}
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default NautilusIcon
